// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"425":"bba379f8","465":"59ec2028","625":"36f22e96","722":"78e69171"}[chunkId] + ".chunk.css";
};